import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { useCart } from "../context/CartContext";
import { FaTrash, FaPlus, FaMinus } from "react-icons/fa";
import styles from "./CartPage.module.css";
// Removed axios since payment happens on the Checkout page now

function CartPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { cartItems, updateQuantity, removeFromCart, clearCart } = useCart();
  const navigate = useNavigate();

  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      // Clean price string
      const priceString = String(item.price).replace(/Br|,/g, "").trim();
      const price = parseFloat(priceString);

      if (!isNaN(price)) {
        return total + price * item.quantity;
      }
      return total;
    }, 0);
  };

  const total = calculateTotal();
  const canCheckout = cartItems.length > 0;

  // --- NEW HANDLER: NAVIGATE TO DELIVERY PAGE ---
  const handleProceedToCheckout = () => {
    if (!canCheckout) return;

    // Redirects the user to the Delivery Option page
    // Make sure your route in App.js is defined as "/delivery"
    navigate("/delivery");
  };

  return (
    <div className={styles.cartPage}>
      <Navbar />
      <div className={styles.cartHero}>
        <h1>Your Cart</h1>
      </div>
      <div className={styles.cartContainer}>
        {cartItems.length === 0 ? (
          <div className={styles.cartEmpty}>
            <p>Your cart is empty.</p>
            <Link to="/products">
              <button className={styles.cartContinueShopping}>
                Continue Shopping
              </button>
            </Link>
          </div>
        ) : (
          <>
            <div className={styles.cartItemsList}>
              {cartItems.map((item) => (
                <div key={item.id} className={styles.cartItem}>
                  <div className={styles.itemImage}>
                    <img src={item.img} alt={item.name} />
                  </div>

                  <div className={styles.itemDetails}>
                    <h3>{item.name}</h3>
                    <p className={styles.itemPrice}>{item.price}</p>
                  </div>

                  <div className={styles.itemActions}>
                    <div className={styles.quantityControls}>
                      <button
                        onClick={() =>
                          updateQuantity(item.id, item.quantity - 1)
                        }
                        disabled={item.quantity <= (item.minQuantity || 1)}
                      >
                        <FaMinus />
                      </button>
                      <span>{item.quantity}</span>
                      <button
                        onClick={() =>
                          updateQuantity(item.id, item.quantity + 1)
                        }
                        disabled={
                          item.maxQuantity && item.quantity >= item.maxQuantity
                        }
                      >
                        <FaPlus />
                      </button>
                    </div>
                    <button
                      onClick={() => removeFromCart(item.id)}
                      className={styles.removeBtn}
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.cartSummary}>
              <h2>Order Summary</h2>
              <div className={styles.summaryRow}>
                <span>Subtotal</span>
                <span>{total.toLocaleString("en-US")} Br</span>
              </div>
              <div className={styles.summaryRow}>
                <span>Shipping</span>
                <span>Calculated at next step</span>
              </div>
              <div className={`${styles.summaryRow} ${styles.total}`}>
                <span>Total</span>
                <span>{total.toLocaleString("en-US")} Br</span>
              </div>

              <button
                className={styles.checkoutBtn}
                disabled={!canCheckout}
                onClick={handleProceedToCheckout}
              >
                Proceed to Checkout
              </button>

              <button className={styles.clearCartBtn} onClick={clearCart}>
                Clear Cart
              </button>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default CartPage;
